export default "__VITE_ASSET__e0fa3a2a__"